// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"38d48ca7","629":"5016715b","869":"4c0f8b38","974":"39d63b22"}[chunkId] + ".chunk.js";
};